/**
 * 公用状态
 */
const index = {
  state: {
    fullscreenLoading: false
  },
  mutations: {
    FULL_SCREEN_LOADING(state, i) {
      state.fullscreenLoading = i
    },
  },
  actions: {
    fullscreenLoading: ({ commit }, i) => {
      commit('FULL_SCREEN_LOADING', i)
    }
  },
  getters: {
    fullscreenLoading: state => state.fullscreenLoading
  }
}

export default index